export const adminInput =
  "w-full rounded-lg border border-charcoal/15 bg-white px-3.5 py-2.5 text-sm text-charcoal placeholder:text-charcoal/35 focus:border-gold-dark focus:outline-none";

export const AdminField = ({ label, children }) => (
  <div>
    <label className="mb-1.5 block text-[11px] font-bold uppercase tracking-[0.15em] text-charcoal/50">{label}</label>
    {children}
  </div>
);

export const SaveBar = ({ saving, onCancel }) => (
  <div className="flex gap-3 pt-2">
    <button type="submit" data-testid="admin-save-button" disabled={saving}
      className="rounded-full bg-charcoal px-6 py-2.5 text-xs font-bold text-gold transition-opacity disabled:opacity-60">
      {saving ? "Saving…" : "Save"}
    </button>
    {onCancel && (
      <button type="button" onClick={onCancel} data-testid="admin-cancel-button"
        className="rounded-full border border-charcoal/20 px-6 py-2.5 text-xs font-bold text-charcoal/60">
        Cancel
      </button>
    )}
  </div>
);
